import { poolDetailSearchSchema } from "@blockdaemon/widget-host";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { DefiPoolDetailPage } from "../../features/defi/pages/defi-pool-detail-page";

export const Route = createFileRoute("/_layout/defi/pool/$tokenAddress/$protocolId")({
  component: DefiPoolDetailPage,
  validateSearch: zodValidator(poolDetailSearchSchema),
});
